module.exports = __webpack_public_path__ + "static/media/guide_step1.eedf8f63.png";